<template>
    <div class="_content">
        <div class="search">
            <van-search v-model="bankName" shape="round" placeholder="请输入搜索关键词" />
        </div>
        <div class="main">
            <div class="list">
                <div
                    class="li bottom-line"
                    v-for="(item, index) in bankList"
                    :key="item.code"
                    @click="clickBank(item)"
                >{{item.text}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import config from '@/configs/config'

export default {
    data() {
        return {
            bankName: '',
            bankList: [],
            cachBankList: [] // 缓存门店列表
        }
    },
    created() {
        this.init()
    },
    mounted() {
        this.$watch('bankName', tuhu.util.debounce((newVal, oldVal) => {
			if (newVal.trim() === oldVal.trim()) return
			if (!this.cachBankList.length) return

			this.bankList = this.cachBankList.filter(item => {
				return item.text.indexOf(newVal) > -1
			})
		}, 200))
    },
    methods: {
        init() {
            let bankList = tuhu.sessionStorage.getItem('bankList')
            if (bankList) {
                this.bankList = JSON.parse(bankList)
                this.cachBankList = JSON.parse(bankList)
            } else {
                this.getBankList()
            }
        },
        async getBankList() {
            try {
                const data = await tuhu.fetch(`${config.apis.GET_BANK_LIST}?level=1&type=3`)
                if (data && data.code === '200') {
                    this.bankList = data.data
                    this.cachBankList = data.data
                    tuhu.sessionStorage.setItem('bankList', JSON.stringify(data.data))
                } else {
                    console.log(`${config.apis.GET_BANK_LIST}`, data.message)
                    tuhu.toast(data.message || '网络错误')
                }
            } catch (e) {
                console.log(`${config.apis.GET_BANK_LIST}`, e)
            }
        },
        clickBank(item) {
            tuhu.store.commit('setBankInfo', JSON.stringify(item))
            setTimeout(() => { tuhu.navigateBack() }, 80)
        }
    }
}
</script>

<style lang="less" scoped>
    ._content {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        background: #f5f5f5;
        .search {
            height: 3rem;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
        }
        .main {
            position: absolute;
            top: 3rem;
            left: 0;
            right: 0;
            bottom: 0;
            overflow: auto;
            .list {
                height: 100%;
                .li {
                    background: #fff;
                    padding: .75rem;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/common/bankList.vue